export default "__VITE_ASSET__cfOGz54R__"